import { EyeOutlineIcon } from "./EyeOutlineIcon";
import { EyeSlashOutlineIcon } from "./EyeSlashOutlineIcon";

interface Props {
  showPassword: boolean;
  isError: boolean;
  onClick: () => void;
}

export const PasswordEyeIcon: React.FC<Props> = ({
  showPassword,
  isError,
  onClick,
}) => {
  const color = isError ? "text-semantic-text-error-primary" : "text-gray-800";
  return (
    <div>
      {showPassword ? (
        <EyeOutlineIcon onClick={onClick} color={color} />
      ) : (
        <EyeSlashOutlineIcon onClick={onClick} color={color} />
      )}
    </div>
  );
};
